import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import './privacy.page.scss'
import { Language } from '../../enum/language.enum'

export const PrivacyPage = () => {
    const { t, i18n } = useTranslation()

    return (
        <main className="page--privacy">
            <div className="privacy-div">
                <div className="title-container">
                    <NavLink to="/login">
                        <button className="button-back">
                            <img alt="Vissza gomb" className="back" src="/image/ic_arrow_left.svg" />
                        </button>
                    </NavLink>

                    <h2>{t('login_privacy_policy_button')}</h2>
                </div>

                <iframe className="privacy-frame" src={`privacy/privacy_${Language.fromLanguageCode(i18n.language)}.html`}></iframe>
            </div>
        </main>
    )
}
